function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Divider, Skeleton, Button, Modal, Space, Spin, Alert, Breadcrumb, Switch, Tabs, notification, Drawer, Statistic, Card } from 'antd';
import Common from "../components/includes/Common";
import { TrashFill, PencilSquare, Plug, BoxArrowInRight, BoxFill, MapFill, CartCheckFill, ClockHistory, Truck, Activity, PersonFill, KeyFill, CashCoin, Plus, ExclamationCircleFill, PeopleFill, XCircleFill } from 'react-bootstrap-icons';
import EditUser from "../components/forms/EditUser";
import EditUserPassword from "../components/forms/EditUserPassword";
import ProvideItemsToAgent from "../components/forms/ProvideItemsToAgent";
import AddAgent from "../components/forms/AddAgent";
import SalesHistory from "../components/SalesHistory";
import AbortSales from "../components/AbortSales";
import SportsModeIcon from '@iconify-react/flat-color-icons/sports-mode';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Dashboard = function Dashboard() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    users = _useState4[0],
    setUsers = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewUserCreated = _useState6[0],
    setIsNewUserCreated = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedUser = _useState8[0],
    setSelectedUser = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataUpdated = _useState0[0],
    setIsDataUpdated = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isProcessing = _useState10[0],
    setIsProcessing = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    operationSuccessMessage = _useState12[0],
    setOperationSuccessMessage = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    operationErroMessage = _useState14[0],
    setOperationErrorMessage = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isUserEditVisible = _useState16[0],
    setIsUserEditVisible = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showProvide = _useState18[0],
    setShowProvide = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showNewAgent = _useState20[0],
    setShowNewAgent = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showUserStock = _useState22[0],
    setShowUserStock = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showSales = _useState24[0],
    setShowSales = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showLeads = _useState26[0],
    setShowLeads = _useState26[1];
  var handleDelete = function handleDelete(u) {
    setSelectedUser(u);
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: 'La supression de ' + u.prenom + '?',
      onOk: function onOk() {
        setIsProcessing(true);
        axios.post(Common.baseApiUrl + 'deleteuser', {
          id: u.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          setIsProcessing(false);
          if (response.data.status == 200) {
            setOperationSuccessMessage(response.data.message);
            setIsDataUpdated(true);
          } else {
            setOperationErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          setIsProcessing(false);
          setOperationErrorMessage(response.data.message);
        }).then(function () {
          setIsDataUpdated(false);
        });
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  var handleEdit = function handleEdit(u) {
    setSelectedUser(u);
    setIsUserEditVisible(true);
  };
  var switchStatus = function switchStatus(checked, u) {
    var action = checked == false ? 'Bloquage' : 'Débloquage';
    axios.post(Common.baseApiUrl + 'witchuserstatus', {
      current: u.status,
      aid: Common.currentUser.id,
      uid: u.id
    }).then(function (response) {
      if (response.data.status == 200) {
        //setIsDataUpdated(true);  
        notification.success({
          message: "Ok!",
          description: response.data.message
        });
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: 'Une erreur est survenue'
      });
    });
  };
  useEffect(function () {
    setIsNewUserCreated(false);
    setIsDataUpdated(false);
    axios.get(Common.baseApiUrl + 'getalldeliverypeople/' + Common.currentUser.id).then(function (response) {
      setIsDataLoading(false);
      setUsers(response.data.users);
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [isNewUserCreated, isDataUpdated]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ContextHolder, /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Breadcrumb, {
            items: [{
              title: /*#__PURE__*/_jsx("span", {
                children: "ALO-GAZ"
              })
            }, {
              title: "Tableau de bord"
            }]
          }), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "CA du jour",
              value: 0,
              suffix: "GnF",
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(CashCoin, {
                size: 25
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#EC742C"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Agents actifs",
              value: 0,
              suffix: "/ 6",
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(SportsModeIcon, {
                height: "26px"
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#0447A5"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Total livraisons aujourdh'ui",
              value: 0,
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(Truck, {
                size: 25
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#0447A5"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx(Statistic, _defineProperty({
              title: "Livraisons en attente",
              value: 0,
              precision: 0,
              styles: {
                content: {
                  color: '#037380'
                }
              },
              prefix: /*#__PURE__*/_jsx(ClockHistory, {
                size: 25
              })
            }, "styles", {
              title: {
                fontSize: "15px"
              },
              content: {
                color: "#0447A5"
              },
              value: {
                fontSize: "20px"
              }
            }))
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: /*#__PURE__*/_jsx("div", {
            className: "al-card",
            style: {
              minHeight: "300px"
            },
            children: isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Table, {
                responsive: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: "Agent"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Status"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Livraisons (7j)"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "D\xE8rni\xE8re activit\xE9 (7j)"
                    }), /*#__PURE__*/_jsx("th", {})]
                  })
                }), /*#__PURE__*/_jsx("tbody", {
                  children: users.map(function (u) {
                    return /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsxs(Space, {
                          orientation: "vertical",
                          children: [/*#__PURE__*/_jsx("b", {
                            children: u.prenom + " " + u.nom
                          }), /*#__PURE__*/_jsx("span", {
                            children: u.mobile.slice(3)
                          })]
                        })
                      }), /*#__PURE__*/_jsx("td", {}), /*#__PURE__*/_jsx("td", {}), /*#__PURE__*/_jsx("td", {}), /*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsxs(Space, {
                          direction: "horizontal",
                          children: [/*#__PURE__*/_jsx(Switch, {
                            onChange: function onChange(checked) {
                              switchStatus(u, checked);
                            },
                            size: "default",
                            checked: u.status == 1
                          }), /*#__PURE__*/_jsx(Button, {
                            type: "default",
                            onClick: function onClick() {
                              handleEdit(u);
                            },
                            children: /*#__PURE__*/_jsx(PencilSquare, {
                              size: 18
                            })
                          })]
                        })
                      })]
                    }, u.id);
                  })
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            className: "al-card",
            children: /*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsx(MapFill, {
                size: 20
              }), " Suivi des livraisons"]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx("h6", {
              children: "Livraisons aujourd'hui"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx("h6", {
              children: "Livraisons recentes"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsx(Card, {
            variant: "borderless",
            children: /*#__PURE__*/_jsx("h6", {
              children: "Prochaines livraisons"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Nouveau"
      }),
      open: showNewAgent,
      onCancel: function onCancel() {
        setShowNewAgent(false);
      },
      destroyOnClose: true,
      footer: null,
      width: {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: /*#__PURE__*/_jsx(AddAgent, {
        handler: function handler() {
          setIsDataUpdated(true);
          setShowNewAgent(false);
          notification.success({
            message: "Ok!",
            description: "Opération enrégistrée"
          });
        }
      })
    })]
  });
};
export default Dashboard;